<template>
  <v-container class="my-10" v-show="!loading">
    <div v-if="success">
      <v-row justify="center">
        <v-col cols="12" sm="6" md="5" lg="4">
          <Success :shop="success_message" />
        </v-col>
      </v-row>
    </div>
    <div v-else-if="error">
      <v-row justify="center">
        <v-col cols="12" sm="6" md="5" lg="4">
          <Error :message="error_message" />
        </v-col>
      </v-row>
    </div>
    <v-card outlined flat :disabled="error" v-else>
      <v-card-title> Shopify App : </v-card-title>
      <v-card-text>
        <v-row justify="center" align="center">
          <v-col cols="12" lg="8" sm="12" md="8">
            <v-text-field
              v-if="installInfos.storeId === '0'"
              label="YOUR_STORE.myshopify.com"
              clearable
              type="text"
              v-model="shop"
              solo
              elevation="1"
              color="green"
            >
              <template v-slot:prepend-inner>
                <span class="ma-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    aria-hidden="true"
                    role="img"
                    width="27"
                    height="27"
                    preserveAspectRatio="xMidYMid meet"
                    viewBox="0 0 32 32"
                  >
                    <path
                      d="M20.448 31.974l9.625-2.083s-3.474-23.484-3.5-23.641s-.156-.255-.281-.255c-.13 0-2.573-.182-2.573-.182s-1.703-1.698-1.922-1.88a.415.415 0 0 0-.161-.099l-1.219 28.141zm-4.833-16.901s-1.083-.563-2.365-.563c-1.932 0-2.005 1.203-2.005 1.521c0 1.641 4.318 2.286 4.318 6.172c0 3.057-1.922 5.01-4.542 5.01c-3.141 0-4.719-1.953-4.719-1.953l.859-2.781s1.661 1.422 3.042 1.422c.901 0 1.302-.724 1.302-1.245c0-2.156-3.542-2.255-3.542-5.807c-.047-2.984 2.094-5.891 6.438-5.891c1.677 0 2.5.479 2.5.479l-1.26 3.625zm-.719-13.969c.177 0 .359.052.536.182c-1.313.62-2.75 2.188-3.344 5.323a76.43 76.43 0 0 1-2.516.771c.688-2.38 2.359-6.26 5.323-6.26zm1.646 3.932v.182c-1.005.307-2.115.646-3.193.979c.62-2.37 1.776-3.526 2.781-3.958c.255.667.411 1.568.411 2.797zm.718-2.973c.922.094 1.521 1.151 1.901 2.339c-.464.151-.979.307-1.542.484v-.333c0-1.005-.13-1.828-.359-2.495zm3.99 1.718c-.031 0-.083.026-.104.026c-.026 0-.385.099-.953.281C19.63 2.442 18.625.927 16.849.927h-.156C16.183.281 15.558 0 15.021 0c-4.141 0-6.12 5.172-6.74 7.797c-1.594.484-2.75.844-2.88.896c-.901.286-.927.313-1.031 1.161c-.099.615-2.438 18.75-2.438 18.75L20.01 32z"
                      fill="currentColor"
                    />
                  </svg>
                </span>
              </template>
            </v-text-field>
            <v-row no-gutters justify="center" v-else>
              <v-col cols="auto">
                <v-list>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Store ID</v-list-item-title>
                      <v-list-item-subtitle>
                        {{ installInfos.storeId }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Shop</v-list-item-title>
                      <v-list-item-subtitle>
                        {{ installInfos.url }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>

            <v-card outlined class="mx-auto my-3">
              <v-card-title> Access Scopes: </v-card-title>
              <v-card-text>
                <v-row justify="center" dense>
                  <v-col cols="12" lg="auto" sm="auto" md="auto">
                    <span></span>
                    <v-checkbox
                      v-model="checkboxs"
                      v-for="(scope, index) in scopes"
                      :key="index"
                      :label="scope.text"
                      color="cleed_blue"
                      :value="scope.value"
                      hide-details
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="mb-5">
        <v-row justify="center">
          <v-col cols="12" sm="6" md="6">
            <v-btn
              :loading="btn_loading"
              @click="submit"
              large
              min-width="100%"
              color="primary"
              :disabled="!shop || !checkboxs.length"
            >
              <b> submmit </b>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import Error from "../components/shopify/Error.vue";
import Success from "../components/shopify/Success.vue";
export default {
  name: "ShopifyApp",
  components: {
    Error,
    Success,
  },
  data: () => ({
    shop: "",
    scopes: [
      { text: "Read roducts", value: "read_products" },
      { text: "Read customers", value: "read_customers" },
      { text: "Read orders", value: "read_orders" },
    ],
    checkboxs: [],
    loading: false,
    error: false,
    success: false,
    error_message: "",
    success_message: "",
    installInfos: {},
    btn_loading: false,
  }),
  created() {
    if (this.$route.query.success) {
      this.success = true;
      this.success_message = this.$route.query.shop;
      return;
    }
    if (this.$route.query.error) {
      this.error = true;
      this.error_message = this.$route.query.message;
      return;
    }
    this.$store.dispatch("setLoader", {
      showing: true,
      text: "Checking the instalation key please wait !",
    });
    this.loading = true;
    const urlKey = this.$route.query.key;

    this.$store
      .dispatch("SHOPIFY_KEY_CHECK", {
        key: urlKey,
      })
      .then((r) => {
        this.installInfos = r;

        this.shop = r.url;
        this.$store.dispatch("setLoader", {
          showing: false,
        });
        this.loading = false;
      })
      .catch((err) => {
        this.error = true;
        this.error_message = err.response.data.message;
        this.$store.dispatch("setLoader", {
          showing: false,
        });
        this.loading = false;
      });
  },
  methods: {
    submit() {
      this.$store
        .dispatch("SHOPIFY_INSTALL", {
          shop: this.shop,
          storeId: this.installInfos.storeId,
          scopes: this.checkboxs,
        })
        .then((r) => {
          console.log(this.installInfos);
          this.btn_loading = true;
          window.location = r.installURL;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
